export enum TagType {
    // Compressor Tags
    SUCTION_FLOWRATE = 'suction_flowrate',
    SUCTION_PRESSURE = 'suction_pressure',
    DISCHARGE_PRESSURE = 'discharge_pressure',
    SUCTION_TEMPERATURE = 'suction_temperature',
    DISCHARGE_TEMPERATURE = 'discharge_temperature',
    ASV_OPENING= 'asv_opening',
    ASV_OPENNING= 'asv_openning',
    INTRASYSTEM_PRESSURE='intrasystem_pressure',
    PRESSURE_WASTE='pressure_waste',
    PRESSURE_WASTE_VALVE_OPENING='pressure_waste_valve_opening',
    CONSUMED_ENERGY = 'consumed_energy',
    SEPARATOR_FLOWRATE = 'separator_flowrate',
    DELIVERED_POWER_CCIA = 'delivered_power_ccia',
    CCIA_POLYTROPPIC_EFFICIENCY = 'ccia_polytropic_efficiency',
    CCIA_POLYTROPPIC_EFFICIENCY_LOSS = 'ccia_polytropic_efficiency_loss',

    // Turbogenerator Tags
    FUEL_GAS_FLOWRATE = 'fuel_gas_flowrate',
    GENERATED_POWER = 'generated_power',
    AVG_GHG_EMISSIONS = 'avg_ghg_emissions',
    ESTIMATED_MAX_POWER = 'estimated_max_power',
    GENERAL_ESTIMATED_MAX_POWER = 'general_estimated_max_power',
    CURRENT_LOAD = 'current_load',
    GENERAL_POWER_RESERVE = 'general_power_reserve',
    POWER_RESERVE = 'power_reserve',

    // Flare Tags
    FLARE_GAS_FLOWRATE = 'flare_gas_flowrate',

    // Pump Tags
    WATER_FLOWRATE = 'water_flowrate',
    CORRECTED_WATER_FLOWRATE = 'water_flowrate_corrected',
    GAS_FLOWRATE = 'gas_flowrate',
    OIL_FLOWRATE = 'oil_flowrate',
}
